import React, { useEffect, useState } from 'react';
import { Box, Flex, Heading, SimpleGrid, Skeleton, Stack, Text } from '@chakra-ui/react';
import { FiBarChart2 } from 'react-icons/fi';
import './BasketLoading.css';

const MESSAGES = [
  'Fetching financial data…',
  'Thinking about cash flows in today’s dollars…',
  'Being greedy while others are fearful…',
  'Looking at the businesses behind the tickers…',
  'Putting the numbers in perspective…',
];

export default function BasketLoading({ bg, borderColor, mutedText }) {
  const [beat, setBeat] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setBeat((value) => value + 1), 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box maxW="900px" mx="auto" px={{ base: 4, md: 8 }} py={{ base: 10, md: 16 }} aria-busy="true">
      <Box bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="2xl"
        p={{ base: 6, md: 10 }} boxShadow="sm">
        <Stack gap={6}>
          <Flex align="center" gap={4}>
            <Flex bg="teal.50" color="teal.700" borderRadius="xl" w="56px" h="56px"
              align="center" justify="center" flexShrink={0} aria-hidden="true">
              <FiBarChart2 size={28} />
            </Flex>
            <Box>
              <Text fontSize="xs" textTransform="uppercase" letterSpacing="wide" color={mutedText} mb={1}>
                Stock baskets
              </Text>
              <Heading as="h1" size="xl">Building your basket</Heading>
            </Box>
          </Flex>
          <Text color={mutedText}>Bringing the companies together for a view of the whole business.</Text>
          <Box>
            <Text role="status" aria-live="polite" fontWeight="medium" mb={3} minH="1.5em">
              {MESSAGES[beat % MESSAGES.length]}
            </Text>
            <Box role="progressbar" aria-label="Loading basket financials" aria-valuetext="Waiting for financial data"
              h="8px" borderRadius="full" bg="teal.100" overflow="hidden">
              <Box className="basket-loading-bar" h="100%" w="35%" bg="teal.500" borderRadius="full" />
            </Box>
            <Text fontSize="sm" color={mutedText} mt={3}>
              {beat >= 4 ? 'Some companies take a little longer. Thanks for your patience.' : 'Your basket will appear as soon as the numbers are ready.'}
            </Text>
          </Box>
        </Stack>
      </Box>
      <SimpleGrid columns={{ base: 1, md: 3 }} gap={4} mt={6} aria-hidden="true">
        {['Combined financials', 'Valuation ratios', 'Company breakdown'].map((label) => (
          <Box key={label} bg={bg} borderWidth="1px" borderColor={borderColor} borderRadius="xl" p={5}>
            <Text fontSize="sm" color={mutedText} mb={4}>{label}</Text>
            <Skeleton h="7" w="60%" mb={3} />
            <Skeleton h="3" w="85%" />
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
}
